import React from "react"
import PropTypes from "prop-types"

import CurrencyForm from "apps/currencies/Currency/CurrencyForm"
import { reverse } from "utils/urls"

export default function CurrencyUpdate(props) {
  return (
    <CurrencyForm
      {...props}
      isUpdate
      actionEndpoint={`/currencies/${props.match.params.id}/`}
      successUrl={reverse("currencyList")}
    />
  )
}

CurrencyUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
